<template>
<div>
    <ollaHead class="header" :isScroll="isScroll" @changeShowAddr="changeShowAddr" ></ollaHead>

    <div class="indexMain">
        <div class="main1">
            <div class="main1_t1">OLLA<br>Your Overseas Life Assistant</div>
            <div class="main1_t2">
                Providing high-quality and convenient life services to help you handle daily tasks abroad with ease, allowing you to focus on more important matters. We are committed to building a warm and caring platform, where you can feel the comfort and peace of home amidst your busy life.
            </div>
            <div class="d-f tabs">
                <div @click="scrollToAnchor('souji')" class="main1_tab">
                    <img src="../assets/icon_clean.png"/>
                    <div class="tab_text">CLEAN</div>
                </div>
                <div @click="scrollToAnchor('repair')" class="main1_tab">
                    <img src="../assets/icon_repair.png"/>
                    <div class="tab_text">REPAIR</div>
                </div>
                <div @click="scrollToAnchor('run')" class="main1_tab">
                    <img src="../assets/icon_run.png"/>
                    <div class="tab_text">RUN</div>
                </div>
                <div @click="scrollToAnchor('chef')" class="main1_tab">
                    <img src="../assets/icon_chef.png"/>
                    <div class="tab_text">CHEF</div>
                </div>
                <div @click="scrollToAnchor('pets')" class="main1_tab">
                    <img src="../assets/icon_pets.png"/>
                    <div class="tab_text">PETS</div>
                </div>
            </div>
        </div>

        <div class="d-f tabTitle">
            <img class="iconTitle" src="../assets/icon_title.png"/>
            <div class="titleText">Featured Services</div>
            <img class="iconTitle" src="../assets/icon_title.png"/>
        </div>

        <div id="souji" class="souji divSouji">
            <div class="divSouji_d1">
                <div class="soujiTop">
                    <img src="../assets/souji_img_1.png"/>
                    <div>OLLA CLEAN — Your Home Cleaning Expert</div>
                    <div>Dedicated to providing you with efficient and professional cleaning solutions. Whether it's daily cleaning, deep cleaning, or tasks requiring professional equipment and techniques, OLLA CLEAN brings your home a refreshing clean experience.
                    </div>
                </div>
                <img class="contextImg" src="../assets/souji_img_5.png"/>
            </div>
            <div class="serveBoxs">
                <div class="serveBox">
                    <div class="d-f p-r serveBoxTop">
                        <img src="../assets/souji_img_2.png"/>
                        <div>Daily Cleaning</div>
                        <div style="cursor: pointer;" @click="changeShowContext('clean-1')">Service Details</div>
                    </div>
                    <div class="serveBoxbottom">
                        <div class="serveContext">
                            We provide essential cleaning services for your daily life to ensure a tidy and hygienic home. Our team will quickly and efficiently complete the tasks according to your needs, helping you maintain a comfortable living environment.
                        </div>
                        <div class="servePrice">
                            <div class="f-1">￥<span>3300</span>/hour (tax included) starting</div>
                            <div style="cursor: pointer;" @click="changeShowPrice('clean-1')">Pricing Details</div>
                        </div>
                    </div>
                </div>

                <div class="serveBox">
                    <div class="d-f p-r serveBoxTop">
                        <img src="../assets/souji_img_4.png"/>
                        <div>Professional Cleaning</div>
                        <div style="cursor: pointer;" @click="changeShowContext('clean-3')">Service Details</div>
                    </div>
                    <div class="serveBoxbottom">
                        <div class="serveContext">
                            Professional deep cleaning of home appliances and furniture, including air conditioners, range hoods, sofas, carpets, and beds. Thorough dust and bacteria removal. Convenient booking and meticulous service for a healthy home.
                        </div>
                        <div class="servePrice">
                            <div class="f-1">￥<span>9900</span>/item (tax included) starting</div>
                            <div style="cursor: pointer;" @click="changeShowPrice('clean-3')">Pricing Details</div>
                        </div>
                    </div>
                </div>

                <div class="serveBox">
                    <div class="d-f p-r serveBoxTop">
                        <img src="../assets/souji_img_3.png"/>
                        <div>Deep Cleaning</div>
                        <div style="cursor: pointer;" @click="changeShowContext('clean-2')">Service Details</div>
                    </div>
                    <div class="serveBoxbottom">
                        <div class="serveContext">
                            For hard-to-reach or rarely cleaned areas, we offer professional deep cleaning with specialized tools and disinfectants to ensure long-lasting cleanliness and care.
                        </div>
                        <div class="servePrice">
                            <div class="f-1">￥<span>4500</span>/hour (tax included) starting</div>
                            <div style="cursor: pointer;" @click="changeShowPrice('clean-2')">Pricing Details</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="repair" class="repair divRun">
            <div class="divSouji_d1">
                <div class="runTop">
                    <img src="../assets/repair_img_1.png"/>
                    <div>OLLA REPAIR — Reliable Home Installation & Repair Expert</div>
                    <div>Specialized in installation and repair of appliances, furniture, plumbing, electricity, and gas systems. Our experienced technicians ensure your home systems run smoothly and safely, making your life more convenient and comfortable.
                    </div>
                </div>
                <img class="contextImg" src="../assets/repair_img_2.png"/>
            </div>
            <div class="serveBoxs">
                <div class="serveBox">
                    <div class="d-f p-r serveBoxTop">
                        <img src="../assets/repair_img_3.png"/>
                        <div>Installation & Repair</div>
                        <div style="cursor: pointer;" @click="changeShowContext('repair-1')">Service Details</div>
                    </div>
                    <div class="serveBoxbottom">
                        <div class="serveContext">
                            Covers a wide range of appliances, furniture, and utilities, ensuring all installations meet safety and performance standards.
                        </div>
                        <div class="servePrice">
                            <div class="f-1">Price negotiable</div>
                            <div style="cursor: pointer;" @click="changeShowPrice('repair-1')">Pricing Details</div>
                        </div>
                    </div>
                </div>
                <div class="serveBox">
                    <div class="d-f p-r serveBoxTop">
                        <img src="../assets/repair_img_4.png"/>
                        <div>Pipe Unclogging</div>
                        <div style="cursor: pointer;" @click="changeShowContext('repair-2')">Service Details</div>
                    </div>
                    <div class="serveBoxbottom">
                        <div class="serveContext">
                            Single/main pipe and manhole unclogging with high-pressure machinery. 24/7 on-site service to quickly solve blockages!
                        </div>
                        <div class="servePrice">
                            <div class="f-1">Price negotiable</div>
                            <div style="cursor: pointer;" @click="changeShowPrice('repair-2')">Pricing Details</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- The rest (RUN, CHEF, PETS, SOCIAL MEDIA) sections would follow same pattern -->

        <div class="d-f tabTitle">
            <img class="iconTitle" src="../assets/icon_title.png"/>
            <div class="titleText">Social Media Accounts</div>
            <img class="iconTitle" src="../assets/icon_title.png"/>
        </div>

        <div class="okerBottom">
            <img class="oker" src="../assets/oker.png"/>
            <div class="b_d1">Follow us and discover more</div>
            <div class="b_d2">Scan to follow the OLLA Xiaohongshu account for the latest updates. Join our community to share life inspirations anytime, anywhere, and discover more beautiful moments!</div>
            <div class="qr qr_guanfang">
                <img src="../assets/qr_guanfang.png"/>
                <div>OLLA Official Account</div>
            </div>

            <div class="qr qr_run">
                <img src="../assets/qr_guanfang2.png"/>
                <div>OLLA CLEAN Official Account</div>
            </div>
        </div>
    </div>
</div>

<el-dialog
    v-model="showAddr"
    title=""
    :width="dialogWidth"
    center
>
    <div slots="title" class="diaTitle">Service Coverage</div>
    <div v-for="item in addrs" v-bind:key="item">
        <div class="dialogCity">· {{ item.city }}</div>
        <div class="dialogArea">
            <span v-for="area in item.areas" v-bind:key="area">{{ area }} > </span>
        </div>
    </div>
</el-dialog>


<el-dialog
    v-model="showContext"
    title=""
    center
    :width="dialogWidth"
>
    <div v-if="serveType=='clean-1'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Service personnel bring some tools</div>
            <div class="dialogBody">· Dust removal: use vacuum cleaners or electrostatic dusters to remove dust from all areas of the room.</div>
            <div class="dialogBody">· Floor cleaning: sweeping, mopping, vacuuming to keep the floor clean.</div>
            <div class="dialogBody">· Desktop and furniture cleaning: cleaning dust and stains on desks, cabinets, sofas, and other furniture.</div>
            <div class="dialogBody">· Kitchen cleaning: cleaning stovetops, cabinet surfaces, countertops, sinks, removing grease and dirt.</div>
            <div class="dialogBody">· Bathroom, washbasin, and toilet cleaning: cleaning bathtubs, toilets, sinks, etc., to remove limescale and mold. Some stains may require professional cleaning.</div>
            <div class="dialogBody">· Garbage disposal: removing indoor trash, replacing trash bags, and cleaning trash cans.</div>
        </div>
    </div>
    <div v-if="serveType=='clean-2'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Service personnel bring some tools</div>
            <div class="dialogBody">· Window cleaning: clean window glass and frames to remove dust, stains, and limescale.</div>
            <div class="dialogBody">· Bathroom glass cleaning: remove stubborn limescale and stains.</div>
            <div class="dialogBody">· Balcony cleaning: clean balcony floors, railings, windows, and plant dust.</div>
            <div class="dialogBody">· Yard and terrace cleaning: sweep yards, terraces, tidy gardens and outdoor furniture.</div>
            <div class="dialogBody">· Wall and ceiling cleaning: remove dust, cobwebs, or stains from walls and ceilings.</div>
            <div class="dialogBody">· Interior cabinet cleaning: clean inside cabinets and organize items.</div>
            <div class="dialogBody">· Cleaning and maintenance of special material furniture or decorations.</div>
            <div class="dialogBody">· Plant dust removal: clean dust off household plant leaves.</div>
        </div>
    </div>
    <div v-if="serveType=='clean-3'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Air conditioner cleaning: clean air filter and casing to remove dust and mold.</div>
            <div class="dialogBody">· Refrigerator cleaning: clean the inside of the fridge, remove odors, and clean the freezer.</div>
            <div class="dialogBody">· Oven and microwave cleaning: remove food residue and grease inside appliances.</div>
            <div class="dialogBody">· Range hood, exhaust fan, and vent cleaning: remove dust and grease.</div>
            <div class="dialogBody">· Floor waxing and polishing.</div>
        </div>
    </div>
    <div v-if="serveType=='run-1'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogTitle">· Shopping errands:</div>
            <div class="dialogBody">· Daily essentials: buy and deliver groceries, beverages, cleaning supplies, etc.</div>
            <div class="dialogBody">· Medicine purchases: for sick or mobility-limited family members.</div>
            <div class="dialogBody">· Supermarket shopping: buy fresh produce like vegetables, fruits, meat, etc.</div>
        </div>
        <div>
            <div class="dialogTitle">· Item delivery:</div>
            <div class="dialogBody">· Document delivery: safely and promptly deliver important documents.</div>
            <div class="dialogBody">· Parcel delivery: help send or forward packages.</div>
            <div class="dialogBody">· Gift delivery: deliver gifts for birthdays, holidays, or special occasions.</div>
        </div>
        <div>
            <div class="dialogTitle">· Food errands:</div>
            <div class="dialogBody">· Takeout pickup: pick up and deliver ordered food.</div>
            <div class="dialogBody">· Restaurant ordering: assist with ordering and picking up meals for gatherings or holidays.</div>
        </div>
        <div>
            <div class="dialogTitle">· Daily tasks:</div>
            <div class="dialogBody">· Repair service contact: arrange appointments with professional repair technicians.</div>
            <div class="dialogBody">· Pickup/delivery services: short-distance pickup or delivery of repaired appliances or furniture.</div>
        </div>
        <div>
            <div class="dialogTitle">· Pet services:</div>
            <div class="dialogBody">· Purchase pet food and supplies.</div>
            <div class="dialogBody">· Pet transport: help transport pets to vets, grooming, or boarding centers.</div>
        </div>
        <div>
            <div class="dialogTitle">· Queuing services:</div>
            <div class="dialogBody">· Hospital registration: especially during peak times or hard-to-book appointments.</div>
            <div class="dialogBody">· Other queuing: wait in line for events, tickets, exhibitions, etc.</div>
        </div>
    </div>
    <div v-if="serveType=='run-2'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogTitle">· Bill payment:</div>
            <div class="dialogBody">· Utility bills: pay water, electricity, gas bills on your behalf.</div>
            <div class="dialogBody">· Phone and internet: handle bill payments for telecom services.</div>
            <div class="dialogBody">· Property fees: pay property management, parking, or maintenance fees.</div>
        </div>
        <div>
            <div class="dialogTitle">· Document processing:</div>
            <div class="dialogBody">· Document handling: assist in submitting applications for ID, passport, driver’s license, etc.</div>
            <div class="dialogBody">· Banking services: help handle transactions or account setups (subject to bank policies).</div>
        </div>
        <div>
            <div class="dialogTitle">· Administrative services:</div>
            <div class="dialogBody">· Visa services: assist in visa applications and submission.</div>
            <div class="dialogBody">· Tax payment: assist with tax submission and documentation.</div>
        </div>
        <div>
            <div class="dialogTitle">· Emergency errands:</div>
            <div class="dialogBody">· Urgent repairs: contact and schedule repairmen for emergencies like power outage or pipe bursts.</div>
            <div class="dialogBody">· Emergency item purchase: buy essential items or medicines in emergencies.</div>
        </div>
    </div>
    <div v-if="serveType=='chef-1'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Daily meals: cook breakfast, lunch, or dinner with a variety from home-style to gourmet dishes.</div>
            <div class="dialogBody">· Custom menus: tailored to your dietary preferences, health needs, or special diets (e.g., vegetarian, sugar-free).</div>
            <div class="dialogBody">· Family gatherings: special menus for family events, birthdays, including appetizers, mains, and desserts.</div>
            <div class="dialogBody">· International cuisine: bring global flavors to your table, such as French, Japanese, or Italian cuisine.</div>
        </div>
    </div>
    <div v-if="serveType=='chef-2'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Healthy meals: customized meals for special health needs (e.g., low-salt, low-fat, gluten-free).</div>
            <div class="dialogBody">· Kids meals: nutritious and tasty menus for children, with balanced vegetables, proteins, and snacks.</div>
            <div class="dialogBody">· Elderly meals: easy-to-digest, nutritious meal plans for seniors based on their health condition.</div>
        </div>
    </div>
    <div v-if="serveType=='pets-1'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Includes feeding, playtime, walking, and cleaning pet areas.</div>
        </div>
        <div>
            <div class="dialogTitle">· Notes:</div>
            <div class="dialogBody">· Pet supplies and food are to be provided by the owner during the service.</div>
        </div>
    </div>
    <div v-if="serveType=='pets-2'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogBody">· Walking or exercising the dog based on its needs to ensure enough physical activity and outdoor time.</div>
        </div>
    </div>
    <div v-if="serveType=='repair-1'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogTitle">· Appliance installation:</div>
            <div class="dialogBody">· TV: wall mounting and tuning services.</div>
            <div class="dialogBody">· Air conditioners: install wall-mounted or floor models and perform tuning.</div>
            <div class="dialogBody">· Fridge & washer: connect water, power, and perform tuning.</div>
            <div class="dialogBody">· Kitchen appliances: install range hoods, stoves, dishwashers, sterilizers.</div>
        </div>
        <div>
            <div class="dialogTitle">· Furniture installation:</div>
            <div class="dialogBody">· Modular furniture: assembly and installation of beds, sofas, cabinets, tables, etc.</div>
            <div class="dialogBody">· Custom furniture: installation of wardrobes, bookcases, etc.</div>
        </div>
        <div>
            <div class="dialogTitle">· Plumbing, electrical, gas installation:</div>
            <div class="dialogBody">· Plumbing: kitchen and bathroom pipe installation and repair.</div>
            <div class="dialogBody">· Electrical: switch, socket, light fixture installation, and wiring.</div>
            <div class="dialogBody">· Gas: installation of gas pipes and gas water heaters.</div>
        </div>
        <div>
            <div class="dialogTitle">· Renovation-related installation:</div>
            <div class="dialogBody">· Door & window installation: indoor/outdoor doors and windows.</div>
            <div class="dialogBody">· Flooring installation: laying wood floors, tiles, etc.</div>
            <div class="dialogBody">· Wall treatment: wallpaper, tiles, and paint application.</div>
        </div>
        <div>
            <div class="dialogTitle">· Network & communication devices:</div>
            <div class="dialogBody">· Router: wireless network setup and installation.</div>
            <div class="dialogBody">· Low voltage systems: wiring and installation of home theater and audio systems.</div>
        </div>
    </div>
    <div v-if="serveType=='repair-2'">
        <div slots="title" class="diaTitle">Service Content</div>
        <div>
            <div class="dialogTitle">· Furniture repair:</div>
            <div class="dialogBody">· Wooden furniture: fix cracks, scratches, and surface wear.</div>
            <div class="dialogBody">· Leather furniture: repair cracks and discoloration.</div>
            <div class="dialogBody">· Modular furniture: replace damaged connectors, fix cabinet doors, etc.</div>
        </div>
        <div>
            <div class="dialogTitle">· Plumbing and electrical repair:</div>
            <div class="dialogBody">· Plumbing: fix leaks, clogs, pipe bursts, etc.</div>
            <div class="dialogBody">· Faucets and valves: fix leaks or loose connections.</div>
            <div class="dialogBody">· Electrical: fix power outages, shorts, faulty sockets, tripping.</div>
            <div class="dialogBody">· Lighting: fix broken fixtures, replace bulbs, faulty switches.</div>
        </div>
        <div>
            <div class="dialogTitle">· Gas repair:</div>
            <div class="dialogBody">· Gas leaks: inspect and repair/replace gas pipes.</div>
            <div class="dialogBody">· Gas water heaters: fix ignition issues, abnormal temperature, leaks.</div>
        </div>
        <div>
            <div class="dialogTitle">· Door & window repair:</div>
            <div class="dialogBody">· Locks: fix stuck locks, replacement, or key issues.</div>
            <div class="dialogBody">· Frames: fix deformation, looseness, or jamming.</div>
            <div class="dialogBody">· Tracks: fix stuck or worn sliding tracks.</div>
            <div class="dialogBody">· Sealing: improve insulation by fixing leaks or drafts.</div>
        </div>
        <div>
            <div class="dialogTitle">· Wall & floor repair:</div>
            <div class="dialogBody">· Wall: repair cracks, peeling, dampness.</div>
            <div class="dialogBody">· Floor: fix wooden floor cracks, bulges, scratches.</div>
            <div class="dialogBody">· Tile: fix cracked, fallen, or damaged tiles.</div>
        </div>
        <div>
            <div class="dialogTitle">· Bathroom repair:</div>
            <div class="dialogBody">· Toilet: fix clogs, leaks, poor flushing.</div>
            <div class="dialogBody">· Shower equipment: repair showerheads, faucets, and drainage issues.</div>
            <div class="dialogBody">· Waterproofing: fix bathroom floor and wall seepage.</div>
        </div>
    </div>
</el-dialog>


<el-dialog
    v-model="showPrice"
    title=""
    :width="dialogWidth"
    center
>
    <div v-if="serveType=='clean-1'">
        <div slots="title" class="diaTitle">
            Price Description - Regular Cleaning
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Service Fee: 3300 JPY/hour. Minimum booking time: 2 hours</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
            <div class="dialogBody">· Number of Staff: Usually 1 staff. If you have special requirements, you can request more staff during booking</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 2 hours cleaning service: 6600 JPY + 880 JPY transportation fee = 7480 JPY</div>
            <div class="dialogBody">· 3 hours cleaning service: 9900 JPY + 880 JPY transportation fee = 10780 JPY</div>
        </div>
        <div class="dialogRed">· Note: For additional requests or long-term cleaning plans, please contact us for a customized quotation.</div>
    </div>
    <div v-if="serveType=='clean-2'">
        <div slots="title" class="diaTitle">
            Price Description - Deep Cleaning
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Service Fee: Starting from 4500 JPY/hour depending on complexity. Balcony/terrace charged by area: within 10㎡ = 8000 JPY, every extra 10㎡ = +4000 JPY. Minimum booking time: 2 hours</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
            <div class="dialogBody">· Number of Staff: Usually 1–2 staff, depending on cleaning area size and complexity</div>
        </div>
        <div>
            <div class="dialogTitle">· Special Project Fees (extra charge if applicable):</div>
            <div class="dialogBody">· Window Cleaning: Based on number/size and difficulty, detailed quote after on-site evaluation</div>
            <div class="dialogBody">· Special Material Furniture Maintenance: Fee negotiable based on material and difficulty</div>
            <div class="dialogBody">· Garden Cleaning: Fee determined based on area and required work, with on-site evaluation</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 2 hours deep cleaning service (1 staff): 9000 JPY + 880 JPY transportation fee = 9880 JPY</div>
            <div class="dialogBody">· 3 hours deep cleaning service (2 staff): 13500 JPY + 1760 JPY transportation fee = 15260 JPY</div>
        </div>
    </div>
    <div v-if="serveType=='clean-3'">
        <div slots="title" class="diaTitle">
            Price Description - Professional Cleaning
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Service Fee: Appliances such as refrigerators, air conditioners, ovens, etc. are mainly charged per item</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
        </div>
        <div>
            <div class="dialogTitle">· Special Project Fees:</div>
            <div class="dialogBody">· Refrigerator Cleaning: 9000 JPY/unit</div>
            <div class="dialogBody">· Wall-mounted Air Conditioner Indoor Unit Cleaning: 9800 JPY/unit, from the 2nd unit -2000 JPY each</div>
            <div class="dialogBody">· Air Conditioner Outdoor Unit Cleaning: 3000 JPY/unit, from the 2nd unit -1000 JPY each</div>
            <div class="dialogBody">· Oven & Microwave Cleaning: 3500 JPY/unit</div>
            <div class="dialogBody">· Range Hood Cleaning: 9800 JPY/unit</div>
            <div class="dialogBody">· Ventilation Fan & Duct Cleaning: 3500 JPY/unit</div>
            <div class="dialogBody">· Floor Waxing & Polishing: Price depends on area and difficulty, on-site evaluation required</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· Refrigerator Cleaning + Transportation: 9000 JPY + 880 JPY = 9880 JPY</div>
            <div class="dialogBody">· 2 Wall-mounted AC Indoor Unit Cleaning + Transportation: 17600 JPY + 880 JPY = 18480 JPY</div>
        </div>
        <div class="dialogRed">· Note: All professional cleaning services’ prices and durations may vary depending on equipment condition and on-site evaluation. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='run-1'">
        <div slots="title" class="diaTitle">
            Price Description - Errand Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Basic Service Fee: 2000 JPY</div>
            <div class="dialogBody">· Hourly Fee: 3300 JPY/hour. From the 2nd hour: less than 0.5h charged as 0.5h, more than 0.5h charged as 1h</div>
        </div>
        <div>
            <div class="dialogTitle">· Travel Fee:</div>
            <div class="dialogBody">· Base Travel Fee: 880 JPY. Extra travel costs will be settled separately according to actual situation</div>
        </div>
        <div>
            <div class="dialogTitle">· Other Fees:</div>
            <div class="dialogBody">· Other expenses during errands need to be prepaid. Any balance will be refunded at order completion</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 1h Errand Service: 2000 JPY basic fee + 3300 JPY service fee + 880 JPY travel fee = 6180 JPY</div>
            <div class="dialogBody">· 2h Errand Service: 2000 JPY basic fee + 6600 JPY service fee + 880 JPY travel fee = 9480 JPY</div>
        </div>
        <div class="dialogRed">· Note: Actual costs depend on service type and travel distance. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='run-2'">
        <div slots="title" class="diaTitle">
            Price Description - Proxy Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Basic Service Fee: 2000 JPY</div>
            <div class="dialogBody">· Hourly Fee: 3300 JPY/hour. From the 2nd hour: less than 0.5h charged as 0.5h, more than 0.5h charged as 1h</div>
        </div>
        <div>
            <div class="dialogTitle">· Travel Fee:</div>
            <div class="dialogBody">· Base Travel Fee: 880 JPY. Extra travel costs will be settled separately according to actual situation</div>
        </div>
        <div>
            <div class="dialogTitle">· Other Fees:</div>
            <div class="dialogBody">· Other expenses during errands need to be prepaid. Any balance will be refunded at order completion</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 1h Proxy Service: 2000 JPY basic fee + 3300 JPY service fee + 880 JPY travel fee = 6180 JPY</div>
            <div class="dialogBody">· 2h Proxy Service: 2000 JPY basic fee + 6600 JPY service fee + 880 JPY travel fee = 9480 JPY</div>
        </div>
        <div class="dialogRed">· Note: Actual costs depend on service type and travel distance. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='chef-1'">
        <div slots="title" class="diaTitle">
            Price Description - Private Chef Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Service Fee: From 3630 JPY/hour depending on dishes and complexity</div>
            <div class="dialogBody">· Minimum Booking Time: 2 hours</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per chef</div>
            <div class="dialogBody">· Number of Staff: Usually 1–2 chefs depending on menu and event scale</div>
        </div>
        <div>
            <div class="dialogTitle">· Special Charges (extra if applicable):</div>
            <div class="dialogBody">· Premium Ingredients: e.g. truffle, foie gras, lobster, quoted separately at market price</div>
            <div class="dialogBody">· International Cuisine: Quotation provided depending on menu and complexity</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 2h Private Chef Service (1 chef): 10000 JPY + 880 JPY transportation = 10880 JPY</div>
            <div class="dialogBody">· 3h Family Dinner (2 chefs): 15000 JPY + 1760 JPY transportation = 16760 JPY</div>
        </div>
        <div class="dialogRed">· Note: Actual service price and time depend on menu and ingredient needs. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='chef-2'">
        <div slots="title" class="diaTitle">
            Price Description - Special Catering Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Healthy Meal: From 6000 JPY/meal depending on menu & ingredients</div>
            <div class="dialogBody">· Kids Meal: From 5000 JPY/meal depending on menu design</div>
            <div class="dialogBody">· Elderly Meal: From 5500 JPY/meal depending on complexity</div>
            <div class="dialogBody">· Basic Service Fee: 2000 JPY</div>
            <div class="dialogBody">· Minimum Booking: 1 meal</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per delivery</div>
        </div>
        <div>
            <div class="dialogTitle">· Special Request Fees (extra if applicable):</div>
            <div class="dialogBody">· Personalized Nutrition Consulting: Extra charge if nutritionist consultation is required</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 1 Healthy Meal: 6000 JPY + 2000 JPY service fee + 880 JPY delivery fee = 8880 JPY</div>
            <div class="dialogBody">· 2 Kids Meals: 10000 JPY + 2000 JPY service fee + 880 JPY delivery fee = 12880 JPY</div>
        </div>
        <div class="dialogRed">· Note: Actual catering price depends on client needs and menu. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='pets-1'">
        <div slots="title" class="diaTitle">
            Price Description - Pet Feeding Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Pet Feeding Service: 2800 JPY/hour</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 2h Pet Feeding: 2800 × 2h + 880 transportation = 6480 JPY</div>
            <div class="dialogBody">· 3h Pet Feeding: 2800 × 3h + 880 transportation = 9280 JPY</div>
        </div>
        <div class="dialogRed">· Note: Actual pet feeding service price depends on pet’s needs and situation. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='pets-2'">
        <div slots="title" class="diaTitle">
            Price Description - Dog Walking Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Dog Walking: 2800 JPY/hour. Minimum booking: 1h</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
        </div>
        <div>
            <div class="dialogTitle">· Total Cost Examples:</div>
            <div class="dialogBody">· 1h Dog Walking: 2800 + 880 = 3680 JPY</div>
            <div class="dialogBody">· 1.5h Dog Walking: 2800 × 1.5 + 880 = 5080 JPY</div>
        </div>
        <div class="dialogRed">· Note: Dog walking price and duration may vary depending on actual needs. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='repair-1'">
        <div slots="title" class="diaTitle">
            Price Description - Installation Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Service Fee: Negotiable depending on project</div>
            <div class="dialogBody">· Minimum Booking Time: Depending on project</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
            <div class="dialogBody">· Number of Staff: Usually 1–2 staff depending on project size</div>
        </div>
        <div class="dialogRed">· Note: Installation service price & duration depend on on-site evaluation. Please consult when booking.</div>
    </div>
    <div v-if="serveType=='repair-2'">
        <div slots="title" class="diaTitle">
            Price Description - Repair Service
            <span style="color: #999999;">(Tax Included)</span>
        </div>
        <div>
            <div class="dialogTitle">· Pricing Information (Tax Included):</div>
            <div class="dialogBody">· Repair Service Fee: Negotiable depending on complexity and materials</div>
            <div class="dialogBody">· Minimum Service Time: Depending on project</div>
            <div class="dialogBody">· Transportation Fee: 880 JPY/per staff</div>
            <div class="dialogBody">· Number of Staff: Usually 1–2 staff depending on project scale</div>
        </div>
        <div class="dialogRed">· Note: Repair service price & duration depend on on-site evaluation. Please consult when booking.</div>
    </div>
</el-dialog>


<el-dialog
    v-model="showKefu"
    title=""
    :width="dialogWidth"
    center
>
    <img style="width: 100%;height: auto;" src="../assets/IG.png"/>
    <div style="text-align: center;font-size: 16px;">@OLLACLEAN</div>
    <div style="text-align: center;font-size: 16px;">IPHONE:07013191220</div>
</el-dialog>


<div class="phone">
    <div class="kefu">
        <div @click="openWx">IG Support</div>
        <div>Service Hours: Open All Year</div>
    </div>
    <div class="fanwei" @click="changeShowAddr">Service Scope</div>
</div>

</template>

<script>
import ollaHead from "@/components/ollaHead.vue";

export default {
    name: "ollaIndex",
    components: {
        ollaHead
    },
    data() {
        return {
            serveType: "",
            showContext: false,
            showPrice: false,
            showAddr: false,
            showKefu: false,
            addrs: [
                {
                    city: "東京都",
                    areas: [
                        "中央区",
                        "千代田区",
                        "新宿区",
                        "港区",
                        "文京区",
                        "台東区",
                        "墨田区",
                        "江東区",
                        "品川区",
                        "目黒区",
                        "大田区",
                        "世田谷区",
                        "渋谷区",
                        "中野区",
                        "杉並区",
                        "北区",
                        "荒川区",
                        "板橋区",
                        "足立区",
                        "葛飾区",
                        "葛飾区",
                        "江戸川区",
                        "豊島区",
                        "武蔵野市",
                        "三鷹市",
                        "調布市",
                        "狛江市",
                        "府中市",
                        "国立市",
                        "国分寺",
                        "市立川市",
                        "小金井市",
                        "小平市",
                        "西東京市",
                        "町田市",
                        "多摩市",
                        "稲城市"
                    ]
                },
                {
                    city: "神奈川県",
                    areas: [
                        "中区",
                        "南区",
                        "西区",
                        "緑区",
                        "港北区",
                        "旭区",
                        "神奈川区",
                        "鶴見区",
                        "都筑区",
                        "保土ヶ谷区",
                        "都泉区",
                        "磯子区",
                        "金沢区",
                        "港南区",
                        "栄区",
                        "瀬谷区",
                        "戸塚区",
                        "川崎区",
                        "高津区",
                        "幸区",
                        "麻生区",
                        "中原区",
                        "宮前区",
                        "多摩区"
                    ]
                },
                {
                    city: "埼玉県",
                    areas: [
                        "北区",
                        "大宮区",
                        "見沼区",
                        "中央区",
                        "桜区",
                        "浦和区",
                        "南区",
                        "緑区",
                        "岩槻区"
                    ]
                }
            ],
            isScroll: "0",
            dialogWidth: "50vw",
        };
    },
    created() {
        this.setDialogWidth()
    },
    mounted() {
        //Your Overseas Life Assistant
        document.title = 'Your Overseas Life Assistant';

        window.addEventListener('scroll', this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.setDialogWidth()
            })()
        }
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        setDialogWidth() {
            var val = document.body.clientWidth
            const def = 768 // 默认宽度
            if (val < def) {
                this.dialogWidth = '90vw';
            } else {
                this.dialogWidth = '50vw';
            }
        },
        handleScroll() {
            this.isScroll = window.scrollY > window.innerWidth * 0.1 ? "1" : "0";
        },
        scrollToAnchor(anchorId){
            const element = document.getElementById(anchorId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        changeShowAddr(){
            this.showAddr = true;
        },
        changeShowContext(_serveType){
            this.showContext = true;
            this.serveType = _serveType;
        },
        changeShowPrice(_serveType){
            this.showPrice = true;
            this.serveType = _serveType;
        },
        openWx(){
            this.showKefu = true;
        }
    }
}
</script>

<style scoped>
.d-f {
    display: flex;
}

.f-1 {
    flex: 1;
}
.p-r{
    position: relative;
}

.header {
    position: fixed;
    width: 100vw;
    height: 6vw;
    z-index: 1000;
    padding: 0;
    opacity: 1;
}

.indexMain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    margin-top: 0px;
    padding: 0;
    overflow-x: hidden;
}

.main1 {
    position: relative;
    width: 100vw;
    height: 47.2vw;
    background-image: url("../assets/top_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
}

.main1_t1 {
    position: absolute;
    top: 8vw;
    left: 0vw;
    width: 100vw;
    text-align: center;
    color: white;
    font-size: 2.8vw;
}

.main1_t2 {
    position: absolute;
    top: 18vw;
    left: 30vw;
    color: white;
    font-size: 1.25vw;
    width: 40vw;
    text-align: center;
}

.tabs {
    position: absolute;
    top: 40vw;
    right: 2.8vw;
    width: 53.5vw;
    height: 4.72vw;
    background-color: white;
    border-radius: 4px;
}

.main1_tab {
    display: flex;
    cursor: pointer;
    flex: 1;
    justify-content: center;
    justify-items: center;
    align-items: center;
}

.main1_tab img {
    width: 2.5vw;
    height: 2.5vw;
    margin-right: 0.8vw;
}

.tab_text {
    font-size: 1.1vw;
    font-weight: bold;
}

.tabTitle{
    margin-top: 2.8vw;
    justify-content: center;
    align-items: center;
}

.iconTitle {
    width: 1.1vw;
    height: 1.7vw;
}

.titleText {
    font-size: 2vw;
    line-height: 2.8vw;
    font-weight: bold;
    margin: 0 0.5vw;
}

.divSouji {
    margin-top: 3vw;
    width: 100vw;
}
.divSouji_d1{
    display: flex;
}

.soujiTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.soujiTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.soujiTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.soujiTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.contextImg {
    width: 50vw;
    height: 33.3vw;
}

.serveBoxs{
    display: flex;
    margin-top: 3.3vw;
    margin-left: 8vw;
}

.divSouji .serveBox {
    width: 26.7vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divSouji .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divSouji .serveBoxTop div{
    position: absolute;
}

.divSouji .serveBoxTop div:nth-child(2){
    top:8.3vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divSouji .serveBoxTop div:nth-child(3){
    top:8.3vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divSouji .serveBoxbottom{
    margin: 0 1.7vw;
}
.divSouji .serveContext{
    margin-top: 1.1vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}

.divSouji .servePrice{
    display: flex;
    margin-top: 0.85vw;
}

.servePrice div:nth-child(1){
    font-size: 0.85vw;
    color: rgba(74, 16, 18, 1);

    span{
        font-size: 1.25vw;
        font-weight: bold;
        color: rgba(255, 78, 82, 1);
    }
}

.servePrice div:nth-child(2){
    font-size: 0.85vw;
    color: rgba(102, 102, 102, 1);
    font-weight: bold;
}


.divRun {
    margin-top: 5.5vw;
    width: 100vw;
}

.runTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.runTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.runTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.runTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.divRun .serveBox {
    width: 40.8vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divRun .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divRun .serveBoxTop div{
    position: absolute;
}

.divRun .serveBoxTop div:nth-child(2){
    top:10vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divRun .serveBoxTop div:nth-child(3){
    top:10vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divRun .serveBoxbottom{
    margin: 0 1.7vw;
}
.divRun .serveContext{
    margin-top: 1.7vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}
.divRun .servePrice{
    display: flex;
    margin-top: 1.4vw;
}


.pets .serveBoxTop div:nth-child(2){
    top:8.5vw;
}
.pets .serveBoxTop div:nth-child(3){
    top:8.5vw;
}
.pets .serveContext{
    margin-top: 1.2vw;
}

.okerBottom{
    position: relative;
    margin-top: 3vw;
    width: 100vw;
    height: 28vw;
    background: #FFFCFC;

    .b_d1{
        position: absolute;
        left: 8vw;
        top: 9.8vw;
        font-weight: bold;
        font-size: 1.5vw;
    }
    .b_d2{
        position: absolute;
        width: 33.8vw;
        left: 8vw;
        top: 14vw;
        font-size: 1vw;
        line-height: 1.7vw;
        color: #666666;
    }

    .oker{
        position: absolute;
        left: 8vw;
        top: 5.8vw;
        width: 16.25vw;
        height: 7vw;
    }

    .qr_guanfang{
        position: absolute;
        left: 67.4vw;
        top: 9.5vw;
    }

    .qr_run{
        position: absolute;
        left: 81.25vw;
        top: 9.5vw;
    }

    .qr{
        text-align: center;
        img{
            width: 7vw;
            height: 7vw;
        }
        div{
            margin-top: 0.5vw;
            text-align: center;
            font-size: 1vw;
            color: #000000;
        }
    }
}

.diaTitle{
    text-align: center;
    font-weight: bold;
    font-size: 1vw;
}

.dialogCity{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogArea{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogTitle{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogBody{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogRed{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 0.8vw;
    line-height: 1.6vw;
    margin: 0 1vw;
    color: #FF4E52;
}

.phone{
    display: none;
}

@media (max-width: 768px) {
    .header {
        height: 48px;
    }

    .main1 {
        background-image: url("../assets/top_bg_phone.png")!important;
        height: 160vw!important;
    }
    .main1_t1{
        left: 16px;
        top: 150px;
        font-size: 20px;
    }
    .main1_t2{
        left: 16px;
        top: 232px;
        font-size: 14px;
        line-height: 22px;
        width: calc(100vw - 32px);
    }
    .tabs{
        top: calc(160vw - 44px);
        left: 16px;
        height: 88px;
        width: calc(100vw - 32px);
        box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    }
    .main1_tab:nth-child(1){
        margin-left: 4vw;
    }
    .main1_tab:nth-child(5){
        margin-right: 4vw;
    }
    .main1_tab{
        display: block;
        text-align: center;
    }
    .main1_tab img{
        width: 32px!important;
        height: 32px!important;
        margin-top: 16px!important;
    }
    .main1_tab .tab_text{
        font-size: 14px;
        line-height: 24px;
        color: #4A1012;
    }
    .tabTitle{
        margin-top: 80px;
    }
    .tabTitle .iconTitle{
        width: 12px;
        height: 18px;
    }
    .tabTitle .titleText{
        font-size: 18px;
        line-height: 21px;
    }
    .divSouji_d1{
        display: block;
    }
    .soujiTop{
        width: 100vw;
        height: 180px;


    }
    .soujiTop div:nth-child(2){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .soujiTop div:nth-child(3){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .soujiTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }
    .contextImg{
        width: calc(100% - 32px);
        height: 66.9vw;
        margin-left: 16px;
        border-radius: 10px;
    }

    .runTop{
        width: 100vw;
        height: 200px;
    }
    .runTop div:nth-child(2){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .runTop div:nth-child(3){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .runTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }

    .serveBoxs{
        overflow-x: auto;
        margin-top: 24px;
        margin-left: 28px;
        display: -webkit-box;
    }
    .serveBox{
        width: 192px!important;
        height: auto!important;
        margin-right: 16px!important;
        border-radius: 15px!important;
    }
    .serveBoxTop{
        justify-content: center;
        overflow: hidden;
        height: 160px!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop img{
        width: auto!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop div:nth-child(2){
        left: 32px!important;
        top: 126px!important;
        font-size: 16px!important;
    }
    .serveBoxTop div:nth-child(3){
        top: 12px!important;
        right: 12px!important;
        width: 88px!important;
        height: 32px!important;
        font-size: 14px!important;
        line-height: 32px!important;
        border-radius: 20px!important;
    }
    .serveBoxbottom{
        margin: 0 16px!important;
    }
    .serveContext{
        font-size: 12px!important;
        line-height: 20px!important;
        margin-top: 16px!important;
    }
    .servePrice{
        display: block!important;
    }
    .servePrice div:nth-child(1){
        font-size: 10px;
        line-height: 12px;
        margin-top: 28px;
    }
    .servePrice div:nth-child(1) span{
        font-size: 16px!important;
        font-weight: bold!important;
        color: rgba(255, 78, 82, 1)!important;
    }
    .servePrice div:nth-child(2){
        font-size: 12px;
        margin-top: 10px;
        padding-bottom: 16px;
    }

    .okerBottom{
        height: 450px;
    }
    .okerBottom .oker{
        position: absolute;
        width: 117px!important;
        height: 50px!important;
        top: 24px!important;
        left: 28px!important;
    }
    .okerBottom .b_d1{
        position: absolute;
        top: 48px!important;
        left: 28px!important;
        font-size: 16px!important;
    }
    .okerBottom .b_d2{
        position: absolute;
        width: calc(100vw - 56px)!important;
        top: 90px!important;
        left: 28px!important;
        font-size: 12px!important;
        line-height: 20px!important;
    }
    .okerBottom .qr{
        text-align: center;
    }
    .okerBottom .qr img{
        width: 100px!important;
        height: 100px!important;
    }
    .okerBottom .qr div{
        font-size: 14px!important;
    }
    .okerBottom .qr_guanfang{
        position: absolute;
        top: 200px!important;
        left: 51px!important;
    }
    .okerBottom .qr_run{
        position: absolute;
        top: 200px!important;
        left: auto!important;
        right: 51px!important;
    }


    .diaTitle{
        font-size: 16px;
        margin-top: -30px;
    }

    .dialogCity{
        font-size: 14px;
        line-height: 28px;
        margin: 0 14px;
    }
    .dialogArea{
        font-size: 14px;
        line-height: 28px;
        margin: 0 24px;
        color: #999999;
    }

    .dialogTitle{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 0;
    }
    .dialogBody{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 12px;
        color: #999999;
    }

    .dialogRed{
        font-size: 12px;
        line-height: 20px;
        margin: 0 14px;
    }

    .phone{
        display: flex;
        position: fixed;
        bottom: 0;
        width: 100vw;
        height: 72px;
        background-color: white;
    }

    .kefu{
        text-align: center;
        background: rgba(255,78,82,0.12);
        border-radius: 20px;
        margin: 12px 12px 0 16px;
        height: 46px;
        width: calc(50vw - 28px);
    }
    .kefu div:nth-child(1){
        color: #FF4E52;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    .kefu div:nth-child(2){
        color: #999999;
        font-size: 10px;
        line-height: 14px;
    }

    .fanwei{
        cursor: pointer;
        text-align: center;
        background: #FF4E52;
        border-radius: 20px;
        color: white;
        margin: 12px 0 0 12px;
        height: 46px;
        width: calc(50vw - 28px);
        line-height: 46px;
        font-size: 14px;
    }
}
</style>
